import { render, staticRenderFns } from "./ProductRadar.vue?vue&type=template&id=f5e52bd8&"
import script from "./ProductRadar.vue?vue&type=script&lang=js&"
export * from "./ProductRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports